<template>
    <section>
        <el-tag :class="!filters.ispublic&&filters.ispublic!=null?'set0':'set1'" @click="changeType(false)">学校专属主题</el-tag>
        <el-tag :class="filters.ispublic?'set0':'set1'" @click="changeType(true)">公共主题</el-tag>
        <el-tag :class="filters.ispublic==null?'set0':'set1'" @click="changeType(null)">全部</el-tag>

        <el-main v-loading="loading" :style="'height:'+(innerHeight-150)">
            <div class="book-list" v-for="(item,index) in list" :key="index" @click.stop="goDetail(item,index)">
                <el-image :src="item.thumbnail" fit="cover" :class="item.checked?'img-check':''"></el-image>
                <div class="foot">
                    <p>{{item.name}}</p>
                    <div class="bottom">
                        <span class="span1">内容模块{{item.items.length}}</span>
                        <span style="width:80px;text-align:right">{{item.price}}</span>
                    </div>
                </div>

                <div class="mark">
                    <span :class="item.checked?'el-icon-success':'el-icon-circle-check'" :style="item.checked?'color:#2EB6AA;':'color:#2EB6AA;'" style="font-size:30px;"></span>
                </div>
            </div>
        </el-main>

        <edit-theme-mission ref="themeRef" :is_edit="0" @openUser="openUser"></edit-theme-mission>

        <!-- 指定选择学生 -->
        <my-class-students ref="getUserRef1" :is_only_one=true :checkIdsS="[]" @getCheckList="getStudentList" @cancelSelect="cancelSelect"></my-class-students>
    
        <!-- 选择人员 -->
        <find-user-by-role ref="findUserRoleRef" @getCheckList="getUsertList" @cancelSelect="cancelSelect"></find-user-by-role>
    </section>
</template>

<script>
import { Drawer } from 'iview';
import {theme,book_index } from '@/api/book'
import {mapState } from "vuex";
import editThemeMission from '@/components/book/editThemeMission'
import myClassStudents from "@/components/common/myClassStudents.vue";
import findUserByRole from "@/components/common/findUserByRole";

export default {
    props:{
       
    },
    data(){
        return{
            list:[],
            visible:false,
            filters: {
                pageSize:999,
                currentPage:1,
                ispublic:false
            },
            loading:false,
            is_can_edit:false,
            theme_id:null,
            select_number:4,
        }
    },
    computed:{
         ...mapState("user", ["school","innerHeight"]),
    },
    components:{
        Drawer,editThemeMission,myClassStudents,findUserByRole
    },

    methods:{
        // 选择人员
        openUser(user_number,data){
            this.$refs.themeRef.visible=false
            this.$refs.findUserRoleRef.openSelectUser(user_number,data)
        },
        getUsertList(items){
            this.$refs.themeRef.getTeacherList(items)
        },

        previewByStudent(){
            this.$refs.themeRef.visible=false
            this.$nextTick(r=>{
                this.$refs.getUserRef1.openSelectUser();
            })
        },
        changeType(val){
            this.filters.ispublic=val
            this.filters.currentPage=1
            this.getList()
        },

        getStudentList(ids,student_name){
            book_index.createBookPage({theme_id:this.theme_id,student_id:ids[0]}).then(res=>{
                if(res.data&&res.data.length>0){
                    let items=[]
                    res.data.forEach((r,i)=>{
                        let arr={
                            component:r.component, 
                            tplBackGroundBOList:[{path:r.backgroup,checked:true}],
                            key:i,
                            back_group:r.backgroup,
                            data:r.data,
                            page_index:i,
                            config:null,
                            data_schema:r.data_schema
                        }
                        items.push(arr)
                    })
                    this.$nextTick(_=>{
                        this.$refs.themeRef.openPreviewStudent(items)
                    })
                }
            })
        },
        cancelSelect(){
            this.$refs.themeRef.visible=true
        },

        goDetail(data,index){
            this.theme_id=data.id
            this.list.forEach((r,i)=>{
                r.checked=i==index?!r.checked:false
            })
            this.list.splice(index,1,this.list[index])
            this.$emit('getCheckTheme',data.id)
        },
        openTheme(id){ //任务打开详情
            this.$nextTick(_=>{
                  this.$refs.themeRef.open(id)
            })
          
        },
        backIndex(data){
            this.visible=false
            this.$emit('openDrawer',data)
        },
        closeTileVisible(data){
            
        },

        getList(){
            if(!this.school||!this.school.id){
                return
            }
            this.loading=true
            this.list=[]
            let param=Object.assign(this.filters,{school_id:!this.filters.ispublic&&this.school?this.school.id:null,theme_name:null,status:'PUTAWAY'})
            theme.find(param).then(res=>{
                this.loading=false
                if(res.data){
                    this.list=res.data.list
                }
            })
        },
        clearCheck(){
            if(this.list&&this.list.length>0){
                this.list.forEach(e=>e.checked=false)
                this.$forceUpdate()
            }
        }
    },

    mounted(){
        this.filters.ispublic=false
        this.getList()
    }
}
</script>

<style scoped lang="scss">
section{
    padding:0;
}

.el-main{
    display: flex;
    flex-wrap: wrap;
    padding:0;
    margin-top: 10;
    .book-list{
        width: 189px;
        margin:0 20 20 0;
        position: relative;
        height: 320px;
        .el-image{
            width: 189px;
            height: 262px;
            margin-bottom: 10px;
        }

        .foot{
            line-height: 1.8;
            font-size: 14px;
            color: #333333;
            .bottom{
                display: flex;
                justify-content: space-between;
                width: 189px;
                .span1{
                    overflow:hidden; 
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    word-break: break-all;
                    flex-grow: 1;
                }
            }

            p{
                overflow:hidden; 
                white-space:nowrap;
                text-overflow:ellipsis;
            }
        }

        .mark{
            position: absolute;
            top:0;
            left:0;
        }
    }
}
.img-check{
    border: 2px solid rgba(46, 182, 170, 1);
}
.set0{
    background: #2EB6AA;
    color:#ffffff;
    border-radius: 4px;
    cursor: pointer;
}
.set1{
    background: #FFFFFF;
    color:#999999;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/book/themeSelect.vue